export default "__VITE_ASSET__bjF7_R8Q__"